mutation DeleteEventTickerBar($eventId: ID!, $tickerBarId: ID!) {
  result: StreamToolsDeleteEventTickerBar(eventId: $eventId, tickerBarId: $tickerBarId) {
    id
    deleted
  }
}
